// import {
//   CertificateTypeEnum,
//   ExemptionExpirationStatusEnum,
//   ExemptionIdTypeEnum,
//   ExemptionReasonEnum,
//   ExemptionStatusEnum,
//   VerificationStatusEnum,
// } from '@commenda/ui/sales-tax/exemptions-tab/exemptions/types';
import { FileBasic } from '@commenda/types/src/file/types';
import {
  CertificateTypeEnum,
  ExemptionIdTypeEnum,
  ExemptionReasonEnum,
  ExemptionStatusEnum,
  VerificationStatusEnum,
} from '../exemptions';
import { JobEntity, JobOperation, JobStatus } from '../job/types';
import { RootFiIntegration } from '@prisma/client';

type ShippingAddress = {
  id?: number;
  address_line_1: string;
  address_line_2?: string;
  address_line_3?: string;
  postal_code: string;
  city: string;
  state: string;
  country: string;
};
export interface CreateCustomerPayload {
  name: string;
  email: string;
  shipping_address?: ShippingAddress;
  corporation_id: number;
}

export interface UpdateCustomerPayload {
  name?: string;
  email?: string;
  shipping_address?: ShippingAddress;
}

export enum CustomerExtend {
  SHIPPING_ADDRESS = 'shipping_address',
  EXEMPTION_METADATA = 'exemption_metadata',
}

export enum ExemptionExpirationStatusEnum {
  EXPIRED = 'EXPIRED',
  NON_EXPIRED = 'NON_EXPIRED',
}

export interface ExemptionFiltersInterface {
  certificateTypes?: CertificateTypeEnum[];
  exemptionJurisdiction?: string[];
  exemptionStatus?: ExemptionStatusEnum;
  expirationStatus?: ExemptionExpirationStatusEnum;
  corporationId: number;
  hasExemption?: boolean;
}

export interface ExemptCustomerQueryParams {
  limit?: number;
  cursor?: string | null;
  extend?: CustomerExtend[];
  filters: ExemptionFiltersInterface;
  name?: string;
}

export interface ExemptionMetadata {
  total_certificates: number;
  certificate_types: CertificateTypeEnum[];
  total_exempted_states: number;
  expired_exemptions_count: number;
  inactive_exemptions_count: number;
  exempted_states: string[];
  active_exemptions_count: number;
  non_expired_exemptions_count: number;
}

export interface SalesTaxCustomer {
  id: string;
  name: string;
  email: string;
  corporation_id: string;
  created_at: number;
  shipping_address?: ShippingAddress;
  source_platform?: RootFiIntegration;
  source_platform_id?: string;
  business_identification_number?: string | null;
  exemption_metadata?: ExemptionMetadata;
}

export type CustomerCreateResponse = SalesTaxCustomer;

export interface SalesTaxCustomerListData {
  customers: SalesTaxCustomer[];
  cursor?: string;
  total_customers: number;
}

export interface SalesTaxCustomerListResponse {
  data: SalesTaxCustomerListData;
  message: string;
}

export type CustomerDeleteResponse = void;

export interface CustomerGetResponse {
  data: SalesTaxCustomer;
  message: string;
}

export interface CustomerUpdateResponse {
  message: string;
}

export interface CustomerExemptionListData {
  exemptions: CustomerExemption[];
  cursor?: string;
  total_exemptions: number;
}

export interface CustomerExemptionResponse {
  data: CustomerExemptionListData;
  message: string;
}

export interface CustomerExemption {
  exemption: {
    country: string;
    state: string;
    reason: ExemptionReasonEnum;
    is_active: boolean;
    end_date?: string;
    identification_type: ExemptionIdTypeEnum;
    identification_number: string;
    is_expired: boolean;
    created_at: number;
    certificate: {
      id: string;
      type: CertificateTypeEnum;
      verification_status: VerificationStatusEnum;
      exemption_certificate_number?: string;
      effective_date: string;
      file_id?: string;
      file_name?: string;
      created_at: number;
    };
  };
}

export type ColumnMapping = {
  fromColumn: string;
  toColumn: string;
};

export interface BulkUploadProps {
  file: FileBasic;
  corporationId: number;
  columnMapping?: ColumnMapping[];
}

export interface BulkJobResponse {
  id: string;
  org_id: string;
  corporation_id: string;
  entity: JobEntity;
  operation: JobOperation;
  status: JobStatus;
  file_name: string;
  failure_reasons: string[] | null;
}

export interface BulkUploadResponse {
  data: {
    job: BulkJobResponse;
  };
  message: string;
}
